<p-toast></p-toast>
<p-table [value]="files">
    <ng-template pTemplate="header">
        <tr>
          <th>
            Name
          </th>
          <th>
            Type
          </th>
          <th>
            Can be sent to school
          </th>
          <th>
            Can be sent to student
          </th>
          <th>
            Needs to be completed by student
          </th>
          <th>
              Size
          </th>
          <th>
            Action
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-file>
        <tr>
            <td>
                <a (click)="downloadFile(file)" class="download-link">
                    {{file.name}}
                </a>
            </td>
            <td>
              <p-dropdown [(ngModel)]="file.fileType" placeholder="Select type" [options]="fileTypes" optionLabel="name" (onChange)="updateFileInformation(file)"></p-dropdown>
            </td>
            <td>
              <p-checkbox [(ngModel)]="file.canBeSentToSchool" [binary]="true" (onChange)="updateFileInformation(file)"></p-checkbox>
            </td>
            <td>
              <p-checkbox [(ngModel)]="file.canBeSentToStudent" [binary]="true" (onChange)="updateFileInformation(file)"></p-checkbox>
            </td>
            <td>
              <p-checkbox [(ngModel)]="file.needsToBeCompleted" [binary]="true" (onChange)="updateFileInformation(file)"></p-checkbox>
            </td>
            <td>
                {{file.size | fileSize}}
            </td>
            <td>
                <p-button styleClass="p-button-danger" icon="pi pi-trash" (onClick)="deleteFile(file)"></p-button>
            </td>
        </tr>
      </ng-template>
</p-table>

<p-fileUpload #fileForm [customUpload]="true" (uploadHandler)="uploadFile($event.files, fileForm)" [maxFileSize]="16000000">
</p-fileUpload>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle">
</p-confirmDialog>
